/**
 * DoSearchPage — route entry for the admin Delivery Order Search & Detail
 * module (ODE-P07-T03). Applies the client-side permission mirror (UX only —
 * the server-side OD-015 `dashboard.view` guard on every endpoint remains the
 * authority) and renders the module. Test seams are passed through (no real
 * fetch in tests).
 *
 * Traces to: ODE-PRD-REQ-044, ODE-PRD-REQ-077, ODE-PRD-REQ-090.
 */

import { useAuth } from '../../auth/AuthContext.js';
import { StateView } from '../../components/StateView.js';
import { hasPermission } from '../../rbac/catalog.js';
import { DoSearchModule, type DoSearchSeams } from './DoSearchModule.js';

export function DoSearchPage({ seams }: { readonly seams?: DoSearchSeams } = {}): JSX.Element {
  const { session } = useAuth();
  const allowed = session !== null && hasPermission(session.staff.roles, 'dashboard.view');
  if (!allowed) {
    return (
      <StateView
        state={{
          kind: 'blocked',
          message: 'Peran tidak memiliki izin dashboard.view untuk halaman ini.',
        }}
      />
    );
  }
  return <DoSearchModule seams={seams ?? {}} />;
}
